// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsPanel_vTqQj {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  max-width: 850px;
  /* margin-left: 8px; */
  align-items: stretch;
  overflow-y: auto;
  max-height: 100%;
  padding: 10px;
  -ms-overflow-style: none;
  overflow-x: visible;
  min-width: 0;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 12px;
}

.settingsPanel_vTqQj::-webkit-scrollbar {
  display: none;
}

.settingsPanelWrapper_ADuiy {
  position: relative;
  overflow: visible;
  flex: 1 1;
  min-width: 0;
  box-sizing: border-box;
  height: 100%;
}

.qrStyleSection_qFMZE {
  min-height: 320px;
}

.logoSection_JloLP {
  min-height: fit-content;
  overflow: visible;
}



@media (max-width: 1200px) {
  .settingsPanel_vTqQj {
    max-width: 100%;
    gap: 18px;
    padding: 16px;
    overflow-x: visible;
  }
}

@media (max-width: 1024px) {
  .settingsPanel_vTqQj {
    gap: 16px;
    padding: 12px;
    margin-left: 0;
    overflow-x: visible;
  }

  .settingsPanelWrapper_ADuiy {
    overflow: visible;
    padding: 0;
  }

  .qrStyleSection_qFMZE {
    min-height: 280px;
  }

  .logoSection_JloLP {
    overflow: visible;
  }


}

@media (max-width: 768px) {
  .settingsPanel_vTqQj {
    max-height: none;
    overflow: visible;
    padding: 12px;
    margin-left: 0;
    width: 100%;
    max-width: 100%;
    gap: 14px;
    order: 2;
  }
  
  .settingsPanelWrapper_ADuiy {
    width: 100%;
    order: 2;
    flex: none;
    overflow: visible;
  }

  .qrStyleSection_qFMZE {
    min-height: auto;
  }

  .logoSection_JloLP {
    min-height: auto;
    overflow: visible;
  }




}

@media (max-width: 600px) {
  .settingsPanel_vTqQj {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    overflow: visible;
  }

  .qrStyleSection_qFMZE,
  .logoSection_JloLP{
    width: 100%;
    overflow: visible;
  }
}

@media (max-width: 480px) {
  .settingsPanel_vTqQj {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    overflow: visible;
  }

  .qrStyleSection_qFMZE,
  .logoSection_JloLP{
    min-height: auto;
    overflow: visible;
  }
}

@media (max-width: 375px) {
  .settingsPanel_vTqQj {
    gap: 8px;
    overflow: visible;
  }
}

@media (max-width: 320px) {
  .settingsPanel_vTqQj {
    gap: 6px;
    overflow: visible;
  }
}

.activeSection_CKCYy {
  flex: 0 0 auto;
  overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/SettingsPanel/SettingsPanel.module.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;;;AAIA;EACE;IACE,eAAe;IACf,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,SAAS;IACT,aAAa;IACb,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,WAAW;IACX,eAAe;IACf,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;;;;AAKF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".settingsPanel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 20px;\n  max-width: 850px;\n  /* margin-left: 8px; */\n  align-items: stretch;\n  overflow-y: auto;\n  max-height: 100%;\n  padding: 10px;\n  -ms-overflow-style: none;\n  overflow-x: visible;\n  min-width: 0;\n  box-sizing: border-box;\n  background-color: #ffffff;\n  border-radius: 12px;\n}\n\n.settingsPanel::-webkit-scrollbar {\n  display: none;\n}\n\n.settingsPanelWrapper {\n  position: relative;\n  overflow: visible;\n  flex: 1;\n  min-width: 0;\n  box-sizing: border-box;\n  height: 100%;\n}\n\n.qrStyleSection {\n  min-height: 320px;\n}\n\n.logoSection {\n  min-height: fit-content;\n  overflow: visible;\n}\n\n\n\n@media (max-width: 1200px) {\n  .settingsPanel {\n    max-width: 100%;\n    gap: 18px;\n    padding: 16px;\n    overflow-x: visible;\n  }\n}\n\n@media (max-width: 1024px) {\n  .settingsPanel {\n    gap: 16px;\n    padding: 12px;\n    margin-left: 0;\n    overflow-x: visible;\n  }\n\n  .settingsPanelWrapper {\n    overflow: visible;\n    padding: 0;\n  }\n\n  .qrStyleSection {\n    min-height: 280px;\n  }\n\n  .logoSection {\n    overflow: visible;\n  }\n\n\n}\n\n@media (max-width: 768px) {\n  .settingsPanel {\n    max-height: none;\n    overflow: visible;\n    padding: 12px;\n    margin-left: 0;\n    width: 100%;\n    max-width: 100%;\n    gap: 14px;\n    order: 2;\n  }\n  \n  .settingsPanelWrapper {\n    width: 100%;\n    order: 2;\n    flex: none;\n    overflow: visible;\n  }\n\n  .qrStyleSection {\n    min-height: auto;\n  }\n\n  .logoSection {\n    min-height: auto;\n    overflow: visible;\n  }\n\n\n\n\n}\n\n@media (max-width: 600px) {\n  .settingsPanel {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n    overflow: visible;\n  }\n\n  .qrStyleSection,\n  .logoSection{\n    width: 100%;\n    overflow: visible;\n  }\n}\n\n@media (max-width: 480px) {\n  .settingsPanel {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n    overflow: visible;\n  }\n\n  .qrStyleSection,\n  .logoSection{\n    min-height: auto;\n    overflow: visible;\n  }\n}\n\n@media (max-width: 375px) {\n  .settingsPanel {\n    gap: 8px;\n    overflow: visible;\n  }\n}\n\n@media (max-width: 320px) {\n  .settingsPanel {\n    gap: 6px;\n    overflow: visible;\n  }\n}\n\n.activeSection {\n  flex: 0 0 auto;\n  overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsPanel": `settingsPanel_vTqQj`,
	"settingsPanelWrapper": `settingsPanelWrapper_ADuiy`,
	"qrStyleSection": `qrStyleSection_qFMZE`,
	"logoSection": `logoSection_JloLP`,
	"activeSection": `activeSection_CKCYy`
};
export default ___CSS_LOADER_EXPORT___;
